var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"common_close",style:({'font-size': _vm.size + 'px', color: _vm.color})},[_vm._v("✕")])}
var staticRenderFns = []

export { render, staticRenderFns }